import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 业务订单(体检)
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class ReserveOrderService extends ServiceBase
{
    /**
     * 获取订单列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getCheckupOrderPage(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getCheckupOrderPage({
            data: data
        });

        return response;
    }

    /**
     * 取消订单
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async onInvalidOrder(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.onInvalidOrder({
            data:{
                id
            }
        });

        return response;
    }

    /**
     * 修改预约时间
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async changeReserve(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.changeReserve({
            data: data
        });

        return response;
    }

    /**
     * 获取订单详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getOrderDetail(id: number): Promise<IHttpResponse>
    {
        let response = await this.apis.getOrderDetail({
            urlPath:{
                id
            }
        });

        return response;
    }

    
}